import Vue from "vue";
import Vuex from "vuex";
import { load, ApiUrl } from "../assets/js/api";
Vue.use(Vuex);

const state = {
  LeftName: [], //左边选择身份证
  lastLeftName: [], //再操作之前左边的数据
  // 统计页面选中选
  chooseNum: 1,
  // 默认选中标签
  getArrayLabel: [], //默认勾选
  // {nameType:"department",label:"泛亚"},{nameType:"name",label:"库里"}
  rightInfo: [], //已选择数据
  personNum: 0, // 选择人数
  lastList: [], //上次默认选人数

  leftListName: [], //左边选择人员信息
  addListName: [], // 新增默认选中
  eduitList: [], //除新增意外其它默认选中
  getIdcard: [], //获取身份证号
  getPersonId: [],
  onlyId: [],
  lastArray: [], //上一次选择的数组
  lastInfo: "", //上一次数据
  getIdcardList: [], //编辑按钮获取身份证列表
  getPersonIdList: [], 
  // 初始化数据
  fullscreenLoading: false,
  customFileLoading: false,
  data: [],
  getPerson: [],
  progressNum: 0,
  downloadStatus: false,
  getName: [], //tree树默认展开和选择数据
  lastPersonId: [],
  lastRightInfo: [],
  getPersonName: [],
  getIds: [],

  // 假期选择人员
  VacationName: [], //默认选中人员

  // 选择人员组件Edit
  CheckedNodes: [], // 已选组织树节点
  ShowChecked: [], // 已选展示
  PersonIdList: [],
  OrgIdList: [],
  CheckedPerson: [], // 已选的人员姓名

  // 选择人员组件Add
  AddCheckedNodes: [], // 已选组织树节点
  AddShowChecked: [], // 已选展示
  AddIdCardList: [],
  AddOrgIdList: [],
  AddCheckedPerson: [], // 已选的人员姓名

  showAuthentication: false, //认证弹框显示
  showEnable: false, //启用产品功能弹框显示
  showProtocol: false, //签署协议弹框显示

  userInfo:{},
  statusInfo: {},
};
const mutations = {
  // 删除已选择信息
  delInfo(state, val) {
    state.leftListName = [];
    let valIndex;
    state.rightInfo.map((item,index) => {
      if(item.Id == val){
        return valIndex = index;
      }
    })
    var delInfo = state.rightInfo.splice(valIndex, 1);
    state.rightInfo.forEach(element => {
      if (element.Id) {
        state.leftListName.push(element);
      }
    });
    state.getArrayLabel.splice(
      state.getArrayLabel.indexOf(delInfo[0]["Name"]),
      1
    );
    for (let index = 0; index < state.getPerson.length; index++) {
      if (state.getPerson[index].Id == delInfo[0].Id) {
        state.getPerson.splice(index, 1);
      }
    }
    --state.personNum;
    console.log(delInfo);
    if (state.personNum < 0) {
      state.personNum = 0;
    }
  },
  // 获取勾选节点数据 赋值
  getSelectInfo(state, val) {
    state.rightInfo.push(val);
    console.log(state.rightInfo);
  },
  getNewInfo(state, val) {
    state.rightInfo = val;
  },
  // 弹框初始化
  initTip(state, val) {
    // state.personNum = 0
    for (let index = 0; index < state.rightInfo.length; index++) {
      if (state.rightInfo[index]["Id"]) {
        // state.getPerson.push(state.rightInfo[index]);
        // state.getArrayLabel.push(state.rightInfo[index]);
        // state.getArrayLabel.push(state.rightInfo[index].Name);
        // state.onlyId.push(state.rightInfo[index].Id);
        state.leftListName.push(state.rightInfo[index]); //选择展示默认勾选人
        // console.log(++(state.personNum))
      }
    }
  },
  // 清空人员组件Add的state
  clearAddStore(state) {
    state.AddCheckedNodes = [];
    state.AddShowChecked = [];
    state.AddIdCardList = [];
    state.AddOrgIdList = [];
    state.AddCheckedPerson = [];
  },
  // 清空人员组件Edit的state
  clearEditStore(state) {
    state.CheckedNodes = [];
    state.ShowChecked = [];
    state.PersonIdList = [];
    state.OrgIdList = [];
    state.CheckedPerson = [];
  },

  set_userinfo(state, newData) {
    state.userInfo = newData;
  },
  set_status(state, newData) {
    state.statusInfo = newData;
  },
}; //通过this.$store.commit("delInfo","12") 调用

const actions = {
  async getUserInfo({ commit }) {
    await load("Get", ApiUrl.getLoginUser, function(res) {
      let data = res.data.data.userInfo;
      commit("set_userinfo", data);
    });
  },
  async getStatus({ commit }) {
    await load("Get", ApiUrl.reqGetStatus + "?type=9", function(res) {
      let data = res.data;
      commit("set_status", data);
    });
  },
  getCookie() {
    let arr = document.cookie.split(";");
    for (let i = 0; i < arr.length; i++) {
      let arrSon = arr[i].split("=");
      if (arrSon[0] == "pcToken" && arr[1] != "") {
        // console.log(arrSon[1])
        return arrSon[1];
      }
    }
  }
};
const getters = {};
export default new Vuex.Store({
  state,
  mutations,
  actions
});



// WEBPACK FOOTER //
// ./src/store/store.js